import { createFileRoute } from '@tanstack/react-router';

interface CliLoginSearch {
  code?: string;
}

export const Route = createFileRoute('/cli-login')({
  validateSearch: (search: Record<string, unknown>): CliLoginSearch => ({
    code: typeof search.code === 'string' ? search.code : undefined,
  }),
});
